import { uid } from "@dhx/ts-common/core";
import { el } from "@dhx/ts-common/dom";
import { ICol, IRendererConfig, GridEvents, IRow, IEditor } from "../../types";

export class CheckboxEditor implements IEditor {
	protected _handlers: { [key: string]: (...args) => void };
	protected _cell: { row: IRow; col: ICol };
	protected _config: IRendererConfig;
	protected _checkbox: HTMLInputElement;
	protected _input: HTMLInputElement;
	protected _checked: boolean;

	constructor(row: IRow, col: ICol, config: IRendererConfig) {
		this._config = config;
		this._cell = { row, col };
		this._initHandlers();
	}

	endEdit() {
		const value = this._checked;
		if (this._config.events.fire(GridEvents.beforeEditEnd, [value, this._cell.row, this._cell.col])) {
			this._cell.row = this._config.datacollection.getItem(this._cell.row.id);
			this._config.events.fire(GridEvents.afterEditEnd, [value, this._cell.row, this._cell.col]);
		} else {
			this._input.checked = !value;
		}
	}

	toHTML() {
		if (this._checked === undefined) {
			this._checked = this._cell.row[this._cell.col.id];
		}
		const id = uid();
		return el(
			"div.dhx_checkbox.dhx_cell-editor__checkbox",

			[
				el(
					"label",
					{
						style: {
							display: "none",
						},
						for: id,
					},
					this._checked || "false"
				),
				el("input.dhx_checkbox__input", {
					type: "checkbox",
					_hooks: {
						didInsert: this._handlers.didInsert,
					},
					_key: "cell_editor",
					"data-dhx-id": "cell_editor",
					checked: this._checked,
					id: id,
					style: {
						userSelect: "none",
					},
				}),
				el("span.dhx_checkbox__visual-input"),
			]
		);
	}

	protected _initHandlers() {
		this._handlers = {
			onClick: () => {
				const value = !this._input.checked;
				if (
					this._config.events.fire(GridEvents.beforeEditStart, [
						this._cell.row,
						this._cell.col,
						"checkbox",
					])
				) {
					this._checked = value;

					this._config.events.fire(GridEvents.afterEditStart, [
						this._cell.row,
						this._cell.col,
						"checkbox",
					]);
					this.endEdit();
				} else {
					this._input.checked = !value;
				}
			},
			didInsert: (node: any) => {
				this._checkbox = node.el.parentNode.lastChild;
				this._input = node.el.parentNode.querySelector("input");
				node.el.parentNode.addEventListener("click", this._handlers.onClick);
			},
		};
	}
}
